// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#uti-panel-selected .default-modal .popup-panels-blocks ul .toxicology-text-panels .check-list-woundpanel li .el-checkbox-group .el-checkbox[data-v-72d02582] {\n  white-space: normal;\n}\n#uti-panel-selected .default-modal .popup-panels-blocks ul .toxicology-text-panels .check-list-woundpanel li .el-checkbox-group .el-checkbox .el-checkbox__label[data-v-72d02582] {\n  line-height: 16px;\n}", ""]);
// Exports
module.exports = exports;
